module.exports = {
    i18n: {
        //首页
        MyJournal: '我的期刊',
        Directions: '临床指南',
        Viewmore: '查看更多指南',
        Viewmore: '脑计划',
        China: '中国',
        USA: '美国',
        USEuro: '欧美',
        Directions: '临床指南',
        NewsEvents: '新闻资讯',
        Viewmore: '查看更多资讯',
        //脑计划
        BrainPlan: '脑计划',
        //新闻资讯 
        Hotspots: '热点',
        Progress: '进展',
        //临床指南
        Pleaseentercontent: '请输入内容',
        //学术会议
        PastBrainBankAlliancemeetings: '往期脑库联盟会议',
        Periodicals: '期刊',
        Readall: '阅读全部',
        Conferenceprogramme: '会议日程',
        Organization: '组织机构',
        ConferenceKeynote: '会议主旨',
        GuestIntroduction: '嘉宾介绍',
        //期刊 
        regardingPeriodicals: '关于期刊',
        Viewtheeditorialteam: '查看编辑组',
        //查看详情
        Seedetails: '查看详情',
        //底部 
        LicensingandTechnicalSupport: '许可和技术支持',
        Editquery: '编辑查询',
        Netherlands: '荷兰',
        //了解更多
        Learnmore: '了解更多',
        //资讯推荐
        Informationrecommendation: '资讯推荐',
        //附件
        Attachments: '附件',
        //名誉主编
        HonoraryEditorinChief: '名誉总编辑',
        //主编辑
        ChiefEditor: '主编辑',
        //名誉主编
        ConsultantEditor: '顾问编辑',
        //基础研究方向副主编
        AssociateEditorofBasicResearch: "基础研究方向副主编",
        //临床研究方向副主编
        AssociateEditorofClinicalResearch: '临床研究方向副主编',
        //助理编辑
        AssistantEditor: '助理编辑',
        //详情
        Details: '详情',
        //国外主旨演讲科学家
        ForeignKeynoteSpeechScientists: '国外主旨演讲科学家',
        //国内
        NationalKeynoteSpeechScientists: '国内主旨演讲科学家',
        //国际
        Internationalguestspeakers: '国际演讲嘉宾',
        //国际 
        Domesticspeakers: '国内演讲嘉宾',
        //发布时间 
        Releasetime: '发布时间',
        //阅读全文
        Readthefullarticle: '阅读全文',
        //主编
        EditorChief: '主编',
        //点击此处了解更多期刊信息
        Clickhereformorejournalinformation: '点击此处了解更多期刊信息',
        //介绍
        Introduction: '介绍',
    }
}